import { FC } from 'react';
import { Select } from '@doda/io-react/pc';
import { FormText } from '@doda/io-react/common';
import { IncludedKeywordCategoryRequestCode } from '@doda/api-client/aspida/@types';
import { SuggestItem } from '@doda/common/src/interfaces/suggestDispatcher';
import { DEFAULT_KEYWORD_OPTION, KEYWORD_OPTIONS } from '../../constants';
import style from './index.module.scss';
import { SuggestList } from '../SuggestList';

/**
 * KeywordSelectInputコンポーネントのプロパティ
 */
interface Props {
  /** 「含む」フラグ。キーワードを含む検索かどうか */
  isInclude: boolean;
  /** 検索テキスト */
  searchText: string;
  /** 検索カテゴリ */
  searchCategory: IncludedKeywordCategoryRequestCode | undefined;
  /** テキストが変更された時のハンドラー */
  onChangeText: (event: string) => void;
  /** キーワードカテゴリが更新された時のハンドラー */
  onChangeUpdateKeyword: (value: IncludedKeywordCategoryRequestCode) => void;
  /** インプットにフォーカスが当たった時のハンドラー */
  onFocusInput: () => void;
  /** インプットからフォーカスが外れた時のハンドラー */
  onBlurInput: () => void;
  /** オーバーレイ表示の状態が変わった時のハンドラー（任意） */
  onChangeIsShowOverlay?: () => void;
  /** サジェストリストアイテム */
  suggest: SuggestItem[];
  /** サジェストアイテムがクリックされたときのハンドラー */
  onClickSuggest: (event: React.MouseEvent<HTMLButtonElement>) => void;
  /** サジェストリストをリセットする関数 */
  resetSuggests: () => void;
}

/**
 * 検索サイトバー・キーワード入力コンポーネント
 * @param {Props} props - コンポーネントのプロパティ
 * @returns {JSX.Element} KeywordSelectInputのJSX要素
 */
export const KeywordSelectInput: FC<Props> = ({
  isInclude,
  searchText,
  searchCategory,
  onChangeText,
  onChangeUpdateKeyword,
  onFocusInput,
  onBlurInput,
  onChangeIsShowOverlay,
  suggest,
  onClickSuggest,
  resetSuggests,
}) => {
  const selectedOption = KEYWORD_OPTIONS.find(
    (option) => option.value === searchCategory
  );
  return (
    <>
      <Select
        selectedOption={{
          value: selectedOption?.value ?? DEFAULT_KEYWORD_OPTION.value,
          label: selectedOption?.label ?? DEFAULT_KEYWORD_OPTION.label,
        }}
        onChange={(value) => {
          onChangeUpdateKeyword(value as IncludedKeywordCategoryRequestCode);
          if (onChangeIsShowOverlay) {
            onChangeIsShowOverlay();
          }
        }}
        options={KEYWORD_OPTIONS}
        className={style.keywordSuggest__select}
      />
      <div className={style.keywordSuggest__inputWrapper}>
        <FormText
          value={searchText}
          onChange={onChangeText}
          onFocus={onFocusInput}
          onBlur={onBlurInput}
          autoComplete="off"
          className={style.keywordSuggest__input}
          maxLength={100}
        />
        <div className={style.keywordSuggest__text}>
          {isInclude ? 'を含む' : 'を含まない'}
        </div>
        <SuggestList
          suggests={suggest}
          onClickSuggest={onClickSuggest}
          resetSuggests={resetSuggests}
        />
      </div>
    </>
  );
};
